import axios from 'axios';
import { showErrorNotification } from './claims/notification';

class Api {
    constructor() {
        const service = axios.create({
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            // withCredentials: true,
        });

        service.interceptors.response.use(
            this.handleSuccess,
            this.handleError
        );

        service.getData = async (url, config = {}) => {
            return service.get(url, config).then((response) => response?.data);
        };

        service.postData = async (url, data = {}, config = {}) => {
            return service.post(url, data, config).then((response) => response?.data);
        };

        this.service = service;
    }

    handleSuccess(response) {
        return response;
    }

    handleError(error) {
        if (error.response && error.response.config.handleError === false) {
            return Promise.reject(error);
        }
        let errorMessage = "An unknown error occurred.";
        if (error.response) {
            const responseData = error.response.data;
            if (responseData.errors && typeof responseData.errors === "object") {
                const errorMessages = Object.values(responseData.errors).flat();
                errorMessage = errorMessages[0] || errorMessage;
            } else if (responseData.message) {
                errorMessage = responseData.message;
            } else if (error.response.statusText) {
                errorMessage = error.response.statusText;
            }
        } else if (error.message) {
            errorMessage = error.message;
        }
        showErrorNotification(errorMessage);
    }
}

export default new Api().service;
